import React from 'react';

const AspectWrapper = ({ ratio, children }) => (
  <div
    style={{
      position: 'relative',
      height: '0px',
      paddingTop: 100 / ratio + '%'
    }}
  >
    <div
      style={{
        position: 'absolute',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%'
      }}
    >
      {children}
    </div>
  </div>
);

export default AspectWrapper;



// WEBPACK FOOTER //
// ./src/utils/aspect-wrapper.js